import { render, staticRenderFns } from "./CustomCollapseItem.vue?vue&type=template&id=44d1a5fe&scoped=true&"
import script from "./CustomCollapseItem.vue?vue&type=script&lang=js&"
export * from "./CustomCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomCollapseItem.vue?vue&type=style&index=0&id=44d1a5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d1a5fe",
  null
  
)

export default component.exports